import { Theme, useTheme } from "@mui/material";

export const Slash = () => {
    const theme = useTheme<Theme>();

    const converted = {
        color: theme.bee.text,
        fontSize: "24px",
        margin: "0",
        padding: "0",
        transform: "translateY(5%)"
    }

    return (
        <span style={converted}>
            /
        </span>
    )
}